<script setup lang="ts">
import { LayoutPosition } from 'chart.js/dist/types/layout'
import { TooltipItem } from 'chart.js'
import { Line } from 'vue-chartjs'

const props = defineProps<{
  labels: string[]
  datasets: {
    label: string
    fill?: boolean
    borderColor?: string
    data: number[]
    tension?: number
    backgroundColor?: string
    pointStyle: 'line'
  }[]
}>()
const { formattedNumber } = useFormattedNumber()

const chartOptions = {
  responsive: true,
  maintainAspectRatio: true,
  plugins: {
    legend: {
      position: 'bottom' as LayoutPosition,
      title: { display: true, padding: { right: 50 } },
      labels: { padding: 20, usePointStyle: true, pointStyle: 'circle' },
      align: 'start',
    },
    tooltip: {
      backgroundColor: 'rgba(0,0,0,0.6)',
      usePointStyle: true,
      callbacks: {
        label: (tooltipItem: TooltipItem) =>
          `  ${tooltipItem.dataset.label}: ${formattedNumber(tooltipItem.raw)}`,
      },
    },
  },
  scales: {
    x: {
      grid: { display: false },
    },
    y: {
      display: true,
      grid: { display: false },
      ticks: {
        callback: function (value) {
          return formattedNumber(value)
        },
      },
    },
  },
}

const chartData = computed(() => {
  return { labels: props.labels, datasets: props.datasets }
})
</script>

<template>
  <Line v-if="chartData.labels && chartData.datasets" :data="chartData" :options="chartOptions" />
</template>
